<template>
	<div>
		<div v-for="item in MenuItems" :key="item.ObjectType" >
			<div v-if="item.Visible">
				<!-- Item sans sous-menu  -->
				<hsc-menu-item v-if="item.SubItems && item.SubItems.length == 0" :label="item.Text" class="menuitemObjectType">
					<div slot="body" v-if="item.Icon"  @click="selectDescendants(item.ObjectType)">
						<b-img :src="AbsoluteLink('Icons/' + item.Icon)" />&nbsp;&nbsp;{{ item.Text }} 
					</div>
				</hsc-menu-item>
				<!-- Item avec sous-menu (seulement s'il contient des items enfants visibles) -->
				<hsc-menu-item v-else :label="item.Text">
					<div slot="body" v-if="item.Icon">
						<b-img :src="AbsoluteLink('Icons/' + item.Icon)" />&nbsp;&nbsp;{{ item.Text }} 
					</div>
					<filter-menu-item :MenuItems="item.SubItems" :FilterNode="FilterNode" :MenuSelection="MenuSelection" />
				</hsc-menu-item>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import Component from 'vue-class-component';
	import { InjectReactive, Prop } from "vue-property-decorator";
	import MenuItem from "@/types/MenuItem";
	import { LinkUtils } from "@/components/commons/Utils";
	import TreeNode from '@/types/TreeNode';

	/** Composant item de menu de filtre des sous-types */
	@Component({
		name: 'filter-menu-item',
		components: {
			FilterMenuItem
		}
	})
	export default class FilterMenuItem extends LinkUtils {
		/** Items de menu */
		@Prop()
		public MenuItems!: MenuItem[];

		/** Noeud sur lequel s'applique le filtre */
		@Prop()
		public FilterNode!: TreeNode;

		/** Détermine si l'on doit sélectionner ou déselectionner les noeuds */
		@Prop()
		public MenuSelection!: boolean;

		/** Nom de l'instance d'arborescence à utiliser */
		@InjectReactive()
		private sourceFilterTree!: string;

		/** Fonction associée au bouton "Effacer la sélection"
		 * Suppression de toutes les sélections*/
		private selectDescendants(objectType: string): void {
			this.$store.dispatch(this.sourceFilterTree + "/NodesByObjectType", { node: this.FilterNode, objectType: objectType, checked: this.MenuSelection })
			.catch(err => {
				console.error(err);
				this.$bvToast.toast(this.$t('AnErrorOccured').toString(), { // $t('AnErrorOccured') / Une erreur s'est produite.
					title: this.$t('Error').toString(), // $t('Error') / Erreur
					autoHideDelay: 10000,
					variant: "danger",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			});
		}
	}
</script>

<style scoped>
	:deep(.menuitemObjectType) {
		width: 300px !important;
	}
</style>